import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { Btn } from '../../../AbstractElements';

export const CategoryModal = ({
  modalOpen,
  closeModal,
  formData,
  setFormData,
  createCategory,
  updateCategory,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.id) {
      await updateCategory(formData);
    } else {
      const { id, ...data } = formData;
      await createCategory(data);
    }
  };

  return (
    <Modal isOpen={modalOpen} toggle={closeModal} backdrop="static" keyboard={false}>
      <ModalHeader toggle={closeModal}>
        {formData.id ? 'Editar Categoría' : 'Registrar Categoría'}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Nombre de la categoría</Label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </FormGroup>
          <ModalFooter>
            <Btn attrBtn={{ color: 'secondary', onClick: closeModal }}>
              <i className="fa fa-times"></i>
            </Btn>
            <Btn attrBtn={{ color: 'primary', type: 'submit' }}>
              <i className="fa fa-save"></i>
            </Btn>
          </ModalFooter>
        </Form>
      </ModalBody>
    </Modal>
  );
};
